import { ApplicationStore } from '../states'

export const updateUserRole: (state: ApplicationStore, payload: string) => ApplicationStore = (state, payload) => {
  return {
    ...state,
    userRole: payload,
  }
}

export const removeUserRole: (state: ApplicationStore) => ApplicationStore = (state) => {
  const newState: ApplicationStore = JSON.parse(JSON.stringify(state))

  delete newState.userRole
  return {
    ...newState,
  }
}
